export default __webpack_public_path__ + "static/media/p200-tip-box.f11de7e3.svg";